import UsersTable from "./UsersTable";
import { useEffect, useRef, useState } from "react";
import CreateUserDialog from "./create/CreateUserDialog";
import { useNavigate } from "react-router";
import useAxios from "../../../../../../hooks/useAxios";
import useLoading from "../../../../../../shared/components/loading/useLoading";
import useToastWrapper from "../../../../../../hooks/useToastWrapper";
import useConfirmDialog from "../../../../../../shared/components/confirm-dialog/useConfirmDialog";
import { catchFunction } from "../../../../../../shared/lib/utils";
import SearchInput from "../../../../../../shared/components/input/SearchInput";
import OverviewTabContent from "../../../../../../shared/components/overview-panel/OverviewTabContent";
import OverviewComponent from "../../../../../../shared/components/overview-panel/OverviewComponent";
import {
  API_SECURITY_CENTRE_DROPDOWN_ROELS,
  API_SECURITY_CENTRE_USERS,
  API_SECURITY_CENTRE_USERS_BY_ID,
} from "../../../../../../shared/lib/apiEndpointsResolver";
import { resolveSecurityCentreUserDetail } from "../../../../../../shared/lib/routesResolver";

const UsersOverview = () => {
  const axios = useAxios();
  const { setLoading } = useLoading();
  const [users, setUsers] = useState([]);
  const usersRef = useRef([]);
  const [roles, setRoles] = useState([]);
  const toast = useToastWrapper();
  const navigate = useNavigate();
  const breadcrumbItems = [{ title: "Usuarios" }];
  const deleteUserDialog = useConfirmDialog();
  const [userForDeletion, setUserForDeletion] = useState();

  const findUsers = () => {
    setLoading(true);
    axios
      .get(API_SECURITY_CENTRE_USERS)
      .then((response) => {
        setUsers(response.data);
        usersRef.current = response.data;
      })
      .catch(catchFunction)
      .finally(() => setLoading(false));
  };

  const findRolesDropdown = () => {
    axios
      .get(API_SECURITY_CENTRE_DROPDOWN_ROELS)
      .then((response) => setRoles(response.data))
      .catch(catchFunction);
  };

  const filterUsers = (searchEvent) => {
    const term = searchEvent.target.value.toLowerCase();
    setUsers(
      usersRef.current.filter(
        (x) =>
          x.fullname.toLowerCase().includes(term) ||
          x.username.toLowerCase().includes(term),
      ),
    );
  };

  const onUserCreation = (formValues) => {
    setLoading(true);
    axios
      .post(API_SECURITY_CENTRE_USERS, formValues)
      .then((response) => {
        toast.success(
          `Usuario ${response.data.username} creado correctamente. Se ha enviado un email con las instrucciones de acceso.`,
        );
        navigate(resolveSecurityCentreUserDetail(response.data.id));
      })
      .catch(catchFunction)
      .finally(() => setLoading(false));
  };

  const onUserDeletionClick = (id) => {
    const selectedUser = usersRef.current.filter((x) => x.id === id)[0];
    setUserForDeletion(selectedUser);
    deleteUserDialog.display(
      `Se eliminará del sistema al usuario ${selectedUser.username}. Los roles que tuviese asignados NO se eliminarán.`,
    );
  };

  const onUserDeletion = () => {
    setLoading(true);
    axios
      .delete(API_SECURITY_CENTRE_USERS_BY_ID(userForDeletion.id))
      .then((_) => {
        toast.success(
          `El usuario ${userForDeletion.username} se ha eliminado correctamente`,
        );
        findUsers();
      })
      .catch(catchFunction)
      .finally(() => setLoading(false));
  };

  const OverviewOptions = (
    <>
      <SearchInput
        onChangeHandler={filterUsers}
        placeholder="Buscar por nombre o user"
      />
      <CreateUserDialog onSubmitHandler={onUserCreation} roles={roles} />
    </>
  );

  const usersTabs = [
    {
      trigger: { value: "all", label: "Todos" },
      content: (
        <OverviewTabContent
          value="all"
          title="Histórico de clientes"
          description="Listado completo de clientes en la historia de AdQuiver"
        >
          <UsersTable data={users} onDelete={onUserDeletionClick} />
        </OverviewTabContent>
      ),
    },
    {
      trigger: {
        value: "enabled",
        label: "Activos",
      },
      content: (
        <OverviewTabContent
          value="enabled"
          title="Personal actual de AdQuiver"
          description="Listado de los empleados actuales de AdQuiver"
        >
          <UsersTable
            data={users.filter((x) => x.enabled === true)}
            onDelete={onUserDeletionClick}
          />
        </OverviewTabContent>
      ),
    },
    {
      trigger: {
        value: "disabled",
        label: "Inactivos",
      },
      content: (
        <OverviewTabContent
          value="disabled"
          title="Antiguos empleados de AdQuiver"
          description="Listado de antiguos empleados de AdQuiver"
        >
          <UsersTable
            data={users.filter((x) => x.enabled === false)}
            onDelete={onUserDeletionClick}
          />
        </OverviewTabContent>
      ),
    },
  ];

  useEffect(() => {
    findUsers();
    findRolesDropdown();
  }, []);

  return (
    <>
      {deleteUserDialog.renderDialog(onUserDeletion)}
      <OverviewComponent
        breadcrumbItems={breadcrumbItems}
        options={OverviewOptions}
        tabs={usersTabs}
        defaultTabValue="enabled"
      />
    </>
  );
};

export default UsersOverview;
